/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { decodeToken } from '../decodeToken';

const { REACT_APP_AUTH0_APPLICATION_DOMAIN } = process.env;

function getUserIdFromToken(token: string) {
  const appMetadataKey = `${
    REACT_APP_AUTH0_APPLICATION_DOMAIN ?? ''
  }app_metadata`;

  const decodedtoken = decodeToken(token);

  return decodedtoken?.[appMetadataKey]?.uuid ?? null;
}

export default getUserIdFromToken;
